
<div *ngIf="report != null">
  <div *ngIf="showTitle && report.DisplayName">
    <div style="font-size: 20px; font-weight: bold; white-space: nowrap;">
      {{report.Name}}
    </div>
    <span style="font-size: 13px; font-style: italic; white-space: nowrap;">{{report.Description != null ? report.Description : ''}}</span>
  </div>

  <mat-grid-list [cols]="columnCount">
    <mat-grid-tile *ngFor="let rre of report.ReportReportElements" [rowspan]="rre.RowSpan" [colspan]="rre.ColumnSpan">
      <div style="width: 100%; height: 100%;" [ngSwitch]="rre.ReportElementId">
        <app-workload-speedometer *ngSwitchCase="2" [reportReportElement]="rre" [data]="reportData[rre.ReportReportElementId]"></app-workload-speedometer>
        <app-daily-workload-bar-chart *ngSwitchCase="3" [reportReportElement]="rre" [data]="reportData[rre.ReportReportElementId]"></app-daily-workload-bar-chart>
        <app-daily-workload-production-level3-bar-chart *ngSwitchCase="4" [reportReportElement]="rre" [data]="reportData[rre.ReportReportElementId]"></app-daily-workload-production-level3-bar-chart>
        <app-completion-speedometer *ngSwitchCase="5" [reportReportElement]="rre" [data]="reportData[rre.ReportReportElementId]"></app-completion-speedometer>
        <app-daily-completion-bar-chart *ngSwitchCase="6" [reportReportElement]="rre" [data]="reportData[rre.ReportReportElementId]"></app-daily-completion-bar-chart>
        <app-daily-completion-production-level3-bar-chart *ngSwitchCase="7" [reportReportElement]="rre" [data]="reportData[rre.ReportReportElementId]"></app-daily-completion-production-level3-bar-chart>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</div>
